import { semanticColors } from '../nested';
import { SemanticTextColor } from '../types/ColorTypes';

export const isOfTypeSematicTextColor = (color: string): color is SemanticTextColor => {
  return (Object.keys(semanticColors.semantic.color.text) as readonly string[]).includes(color);
};
